/**
 * Converts bundl_english values to route names
 * @param {string} bundlEnglish - The bundl_english value from API response
 * @returns {string|null} - The route name or null if not found
 */
export const convertBundlEnglishToRoute = (bundlEnglish) => {
  if (!bundlEnglish || typeof bundlEnglish !== "string") {
    return null;
  }

  const mapping = {
    "The Newbie": "newbie",
    "The Foodie": "foodie",
    "The Socialite": "socialite",
    "The Boutiquer": "boutiquer",
  };

  return mapping[bundlEnglish] || null;
};

/**
 * Checks if an order is a Brand Identity order by checking order items
 * @param {Array} itemDetails - Item details to check for Brand Identity items
 * @returns {boolean} - True if it's a Brand Identity order
 */
export const isBrandIdentityOrder = (itemDetails) => {
  // Always check by item details
  if (itemDetails && Array.isArray(itemDetails)) {
    return itemDetails.some(
      (item) => item?.item_name && item.item_name.includes("Brand Identity")
    );
  }
  
  return false;
};

/**
 * Checks if a bundle is a Custom Bundle
 * @param {number|null} bundleId - The bundle ID (null = Custom Bundle)
 * @returns {boolean} - True if it's a Custom Bundle
 */
export const isCustomBundle = (bundleId) => {
  return bundleId === null;
};
